import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('attachments', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('attachments');

      return new ViewModel(params, element);
    },
  },
  template: html,
});